"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cassano-magnago": {
    "3500ddba": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "skipSearch": false
    }],
    "avicoltura-provini": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9440ab7b": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "skipSearch": false
    }],
    "brugorino": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9a3a7f1f": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-bottini": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "16841ea9": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-cattabrega": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ae6824d2": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-della-bonifica": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1df0742b": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-marcora": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "515c98b4": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-piatti": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "736fbddb": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-viscontina": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b4128101": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "skipSearch": false
    }],
    "ca-rossa": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "12d72620": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "skipSearch": false
    }],
    "circolo-cacciatori": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e7a7c0e5": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-del-rosario": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7366ba40": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "skipSearch": false
    }],
    "quadro": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8d0d878c": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dd9414be": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "skipSearch": false
    }],
    "sant-anna": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "03fd5f6c": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "skipSearch": false
    }],
    "spino": [{
      "hkey": "39ea5890",
      "slug": "cassano-magnago",
      "name": "Cassano Magnago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;